import { render, staticRenderFns } from "./SubCategoriasComponent.vue?vue&type=template&id=e5b74388&"
import script from "./SubCategoriasComponent.vue?vue&type=script&lang=js&"
export * from "./SubCategoriasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports